import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import getBoundingAreasByLocation from '../../services/geofencing';
import { selectCurrentLocation } from '../../services/store/modules/geo-service';

const useIsInBounds = (boundingArea: string) => {
  const { latitude, longitude } = useSelector(selectCurrentLocation);
  const userInBoundingArea = useMemo(
    () =>
      getBoundingAreasByLocation({
        longitude,
        latitude,
      }),
    [latitude, longitude],
  );

  const [isInBounds, setIsInBounds] = useState<boolean>(
    userInBoundingArea.includes(boundingArea),
  );

  useEffect(() => {
    setIsInBounds(userInBoundingArea.includes(boundingArea));
  }, [longitude, latitude, boundingArea, userInBoundingArea]);

  return isInBounds;
};

export default useIsInBounds;
